import { Node } from "@tiptap/core";
import { mergeAttributes } from "@tiptap/react";
import { PAGE_CONTENT_HEIGHT } from "../constants";

export const ContentContainer = Node.create({
    name: "contentContainer",
    group: "block",
    content: "pageContent",

    parseHTML() {
        return [
            {
                tag: 'div[data-type="content-container"]',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "div",
            mergeAttributes(HTMLAttributes, {
                "data-type": "content-container",
                style: `height: ${PAGE_CONTENT_HEIGHT}px; overflow: hidden;`,
                class: "content-container",
            }),
            0,
        ];
    },
});
